/**
 * Nome só se for NOME. Devolve `null` para vazio ou para o que é só número, e o
 * degrau seguinte assume — no fim, o rótulo fica "escrevendo..." sem autor, que é
 * melhor que "5511999998888 está escrevendo...".
 *
 * Três fontes independentes podem devolver número no lugar de nome: contato criado
 * sem pushName fica com o próprio número em `nome` (é o que `deveCurarNome` cura no
 * servidor, mas só quando chega uma mensagem depois), `buscarParticipantes` usa o
 * código como último fallback, e participante `@lid` sem resolução PN chega como
 * dígitos do LID — que não são nem telefone de verdade.
 *
 * Descarta separadores antes de decidir: `+55 (11) 99999-8888` é tão número quanto
 * `5511999998888`. Sem piso de comprimento, ao contrário do `\d{8,}` do servidor:
 * aqui não se cura nada, só se decide o que pintar, e nome que é só dígito não é
 * nome em nenhum tamanho.
 *
 * Mora fora do chatStore para a lista de participantes e o "Responder em particular"
 * aplicarem a MESMA regra — e para poder ser testada sem carregar a store.
 */
export function nomeExibivel(nome: string | null | undefined): string | null {
    if (!nome) return null;
    // `.trim()` no retorno: nome com espaço nas pontas pintaria um buraco no rótulo.
    const limpo = nome.trim();
    if (!limpo) return null;
    // Vazio DEPOIS de tirar os separadores também é descarte ("-", "..", "+ ( ) - .").
    // A versão anterior exigia `length > 0` aqui e devolvia essas strings como nome.
    const semSeparadores = limpo.replace(/[\s+()\-.]/g, '');
    if (!semSeparadores || /^\d+$/.test(semSeparadores)) return null;
    return limpo;
}
